export enum ServiceVariantPricingOption {
  From = "FROM",
  Fixed = "FIXED",
  Free = "FREE",
}
